import { render, staticRenderFns } from "./HardwareControl.vue?vue&type=template&id=680bacba&scoped=true"
import script from "./HardwareControl.vue?vue&type=script&lang=js"
export * from "./HardwareControl.vue?vue&type=script&lang=js"
import style0 from "./HardwareControl.vue?vue&type=style&index=0&id=680bacba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680bacba",
  null
  
)

export default component.exports